interface Props {
  color?: string
  width?: number
  height?: number
}

export const Upload1Icon = ({ color = '#6F6F6F', width = 20, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.3105 9.5C19.5865 9.50022 19.8105 9.72399 19.8105 10V19.3105C19.8104 19.5865 19.5864 19.8103 19.3105 19.8105H0.689453C0.413469 19.8104 0.189562 19.5865 0.189453 19.3105V10.0039C0.189662 9.72801 0.413531 9.50401 0.689453 9.50391C0.965466 9.50391 1.18924 9.72794 1.18945 10.0039V18.8105H18.8105V10C18.8105 9.72392 19.0345 9.50011 19.3105 9.5ZM10.0098 0.19043C10.037 0.190986 10.064 0.194246 10.0908 0.199219C10.0938 0.199787 10.0967 0.200552 10.0996 0.201172C10.1289 0.207133 10.1575 0.215339 10.1855 0.226562C10.1874 0.227341 10.1895 0.227715 10.1914 0.228516C10.2502 0.25293 10.3057 0.288164 10.3535 0.335938L15.0088 4.99121C15.2039 5.18645 15.2039 5.50302 15.0088 5.69824C14.8136 5.89345 14.497 5.89335 14.3018 5.69824L10.4961 1.89258V14.1377C10.4961 14.4138 10.2722 14.6376 9.99609 14.6377C9.71995 14.6377 9.49609 14.4138 9.49609 14.1377V1.90039L5.69824 5.69824C5.50299 5.89344 5.18646 5.89344 4.99121 5.69824C4.79611 5.50299 4.79605 5.18643 4.99121 4.99121L9.62305 0.358398C9.68579 0.287813 9.76782 0.236151 9.86133 0.209961C9.86886 0.207797 9.87618 0.204928 9.88379 0.203125C9.89596 0.200331 9.90841 0.199154 9.9209 0.197266C9.94201 0.193914 9.96306 0.191071 9.98438 0.19043C9.98823 0.190342 9.99222 0.189453 9.99609 0.189453C10.0007 0.189454 10.0052 0.190306 10.0098 0.19043Z"
        fill={color}
      />
    </svg>
  )
}
